import { useMediaQuery, useTheme } from '@material-ui/core';
import { CSSProperties, memo } from 'react';
import { KContainer, KImage, KLabel, KLoading, MIcon } from 'uikit';

interface IProps {
  icon: MIcon;
  iconStyle: CSSProperties;
  label: string;
  value: number | string;
  isLoading?: boolean;
}

const TotalCard = ({
  icon,
  iconStyle,
  label,
  value = 0,
  isLoading = false
}: IProps) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <KContainer.View
      padding={isMd ? '0.5rem' : '0.75rem'}
      position="relative"
      br={'2x'}
      style={{
        border: '1px solid #ccc',
        background: '#fff'
      }}
    >
      {isLoading && <KLoading />}

      <KContainer.View
        flex
        row
        alignItems="stretch"
        justifyContent="space-between"
        gap={'0.75rem'}
      >
        <KImage.MuiIcon icon={icon} style={iconStyle} />
        <KContainer.View
          dp="flex"
          flexG={1}
          justifyContent={isMd ? 'flex-end' : 'space-between'}
        >
          <KLabel.Text
            typo="TextMdNormal"
            background="#fff"
            style={
              isMd
                ? {
                    position: 'absolute',
                    left: `${isMd ? 0.5 : 1}rem`,
                    bottom: '90%'
                  }
                : undefined
            }
          >
            {label}
          </KLabel.Text>
          <KLabel.Text typo={isMd ? 'H1' : 'Text4xLgBold'}>{value}</KLabel.Text>
        </KContainer.View>
      </KContainer.View>
    </KContainer.View>
  );
};

export default memo(TotalCard);
